<template>
  <div ref="dom" class="charts chart-bar"></div>
</template>

<script>
import * as echarts from 'echarts'
import { on, off } from '@/libs/tools'

export default {
  name: 'ChartBar',
  props: {
    value: Array,
    text: String,
    subtext: String,
    series: Object
  },
  data () {
    return {
      dom: null
    }
  },
  methods: {
    resize () {
      this.dom.resize()
    },
    updateData (data) {
      this.value = data
      this.initXY()
    },
    initXY () {
      let xAxisData = []
      for (let i = this.value.length - 1; i >= 0; i--) {
        xAxisData.push(this.value[i][this.series.x])
        for (let j = 0; j < this.series.y.length; j++) {
          let seriesY = this.series.y[j]
          if (i === this.value.length - 1) {
            seriesY['data'] = []
          }
          seriesY.data.push(this.value[i][seriesY.key])
        }
      }
      let seriesData = []
      for (let i = 0; i < this.series.y.length; i++) {
        seriesData.push({
          data: this.series.y[i].data,
          name: this.series.y[i].name,
          type: 'bar',
          label: {
            show: true,
            position: 'top',
            textStyle: {
              color: '#555'
            }
          }
        })
      }
      this.initData(xAxisData, seriesData)
    },
    initData (xAxisData, seriesData) {
      let option = {
        title: {
          text: this.text,
          subtext: this.subtext,
          x: 'center'
        },
        legend: {
          icon: 'circle',
          top: '5%',
          right: '5%',
          itemWidth: 6,
          itemGap: 20,
          textStyle: {
            color: '#556677'
          }
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value'
        },
        series: seriesData
      }
      this.dom = echarts.init(this.$refs.dom, 'tdTheme')
      this.dom.setOption(option)
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initXY()
      on(window, 'resize', this.resize)
    })
  },
  beforeDestroy () {
    off(window, 'resize', this.resize)
  }
}
</script>
